/**
 * Both performance screens derive a client score by averaging the scores of its
 * spending campaigns. The averaging is identical; the per-campaign scoring is
 * not — Meta scores on objective-specific KPIs, Google on campaign type — so
 * the campaign scorer is injected.
 */
export const makeClientScorer = (scoreCampaign) => (campaigns) => {
  const activeCampaigns = campaigns.filter(c => c.spend > 0);
  if (activeCampaigns.length === 0) return { score: 0, status: 'inactive' };

  const scores = activeCampaigns.map(c => scoreCampaign(c).score);
  const avgScore = scores.reduce((a, b) => a + b, 0) / scores.length;
  const status = avgScore >= 70 ? 'good' : avgScore >= 40 ? 'warning' : 'critical';

  return { score: Math.round(avgScore), status };
};
